'use client';

import { initReactI18next } from 'react-i18next';
import { i18n } from '@/i18n/i18nInstance';

// react-i18next reads React.createContext at module load, so it must only
// run on the client. Bind the existing server-safe instance to react-i18next
// the first time this module is imported (which only happens inside a client
// component — the Providers tree, or any hook in a 'use client' file).

let bound = false;

function ensureBound() {
  if (bound) return;
  bound = true;
  // .use() is idempotent — react-i18next checks if it's already attached.
  i18n.use(initReactI18next);
}

ensureBound();

export { i18n };
